  /* 国际化zh_tw */

module.exports = {
    base:{
        "nomore" : "それ以上はありません", //沒有更多了
        "sure" : "確定", //确定
        "not_desc" : "説明なし", //暂无描述
    },
    common:{
        "get_code" : "検証コードを取得します", //获取验证码
        "onsale_status" : "该商品已下架", //
        "s_regain" : "s後に再取得します", //s后重新获取
        "regain" : "再取得します", //重新获取
        "cancel" : "キャンセル", //取消
        "select" : "選択", //选取
        "empty_item" : "内容なし", //暂无内容
        "load_fail" : "読み込みエラー", //加载失败
        "tabbar_my_name" : "私の", //我的
    },
    tabbar:{
        "home" : "ホーム", //首页
        "category" : "分類", //分类
        "cart" : "カート", //购物车
        "profile" : "私の", //我的
        "service" : "skype", //客服
    },
    address:{
        "name" : "受取人名前", //收件人姓名
        "name_placeholder" : "如実に受取人の名前を記入してください", //
        "mobile" : "携帯電話番号", //
        "mobile_placeholder" : "パーソナル携帯電話に記入してください", //
		"email" : "Email",
		"email_placeholder" : "E-mail入力します",
        "region" : "所在地区", //
        "region_placeholder" : "市、区、街", //
        "address" : "詳細住所", //
        "address_placeholder" : "詳しい住所を記入してください", //
        "zip" : "郵便番号", //
        "zip_placeholder" : "正しい郵便番号を記入してください", //
        "name_empty" : "受取人の名前を記入してください", //
        "name_less" : "2-50桁文字及び符号制限", //
        "mobile_empty" : "携帯電話番号を記入してください", //
        "mobile_less" : "正しい形式の携帯電話番号を記入してください", //
        "region_empty" : "所在地区を選択してください", //
        "address_empty" : "詳しい住所を記入してください（英語を使う）", //
        "zip_empty" : "郵便番号を記入してください", //
        "save_use" : "保存及び使用", //
        "save" : "保存", //
        "add" : "新規住所追加", //
        "edit" : "お届け住所変更", //
        "delete" : "削除", //
        "list_title" : "お届け住所", //
        "list_title_item" : "管理", //
        "default" : "デフォルト", //
        "list_default" : "デフォルト住所", //
        "list_edit" : "編集", //
        "list_delete" : "削除", //
        "manage_title" : "お届け住所管理", //
        "manage_empty" : "お届け住所が追加されていません", //
        "manage_add" : "お届け住所追加", //
        "confirm_del" : "当該お届け住所を削除しますか？", //
        "confirm_del_title" : "削除確認", //
        "region_select" : "地区を選択してください", //
        "region_cancel" : "キャンセル", //
        "region_confirm" : "確定", //
    },
    auth:{
        "retrieve" : "パスワード忘れた", //密码找回
        "mobile" : "携帯電話番号", //
        "email" : "E-mail", //
        "go_signin" : "ログインする", //
        "sure" : "確定", //
        "signin" : "ログイン", //登录
        "signup" : "登録", //注册
        "fast_signup" : "登録", //快速注册
        "email_signup" : "E-mail登録", //
        "agree" : "登録をクリックして同意します", //
        "agreement" : "「ユーザー協議」", //
        "signup_succ" : "登録完了", //
        "signup_agreement" : "登録協議", //
    },
	auth_signin:{
		"username_placeholder" : "ユーザー名／メールアドレス", //用户名/邮箱/手机号
		"password_placeholder" : "パスワードを入力", //请输入密码
		"forget" : "パスワード忘れた？", //忘记密码？
		"third_party" : "第三者登録", //
		"wechat" : "ウィーチャット", //微信
		"passport_empty" : "パスワードを入力", //请输入密码
		"passport_less" : "6桁以上のパスワードを入力してください", //至少输入6位密码
		"expire" : "ログイン時間切れ", //登录过期
		"username_empty" : "ユーザー名を入力してください", //请输入用户名
	},
	auth_bind:{
		"mobile" : "携帯電話連携", //绑定手机
		"code_placeholder" : "请输入手机验证码", //
		"username_placeholder" : "携帯電話番号を入力してください", //请输入手机号
		"passport_placeholder" : "パスワード設定", //设置密码
		"confirmPassword_placeholder" : "パスワード確認", //确认密码
		"tips" : "6-20桁の数字／ファルファベット／符号", //
		"finish" : "完了", //完成
		"mobile_less" : "正しい形式の携帯電話番号を入力してください", //
		"code_empty" : "検証コードを入力してください", //
		"code_less" : "6桁の検証コードを入力してください", //
		"password_empty" : "パスワードを入力してください", //
		"password_less" : "6-20桁文字及び符号のパスワードを入力してください", //
		"confirmPassword_empty" : "確認パスワードを入力してください", //
		"passport_error" : "確認パスワードと入力パスワードが一致していません", //
	},
	auth_email:{
		"confirm_tips" : "パスワード変更リンクは　に送信しました", //密码修改链接已发送至
		"email_placeholder" : "E-mail入力します", //请输入您的邮箱
		"tips" : "パスワード変更リンクをあなたの連携メールアドレスに送信しました", //我们将发送密码修改链接到您绑定的邮箱
		"send" : "E-mail送信します", //发送邮件
		"empty" : "E-mail入力します", //请输入邮箱
		"validator_error" : "E-mail が間違っています", //邮箱地址不正确
		"username_placeholder" : "ユーザー名", //用户名
		"username_tips" : "ユーザー名は3-25桁、アルファベットと数字を含みます", //
		"passport_tips" : " 6-20桁の数字／ファルファベット／符号", //
		"signup_email_placeholder" : "E-mailアドレス", //邮箱地址
		"email_tips" : "E-mail入力します", //请输入邮箱地址
		"username_empty" : "3-25桁文字及び符号のユーザー名を入力してください", //
		"password_empty" : "パスワードを入力", //请输入密码
		"password_less" : "6-20桁文字及び符号のパスワードを入力してください", //
	},
    auth_mobile:{
        "retrieve_succ" : "あなたのパスワードは携帯電話による再設定の方法を通じて再設定されました"
    },
    balance:{
        "usable_title" : "使用可能資金", //
        "desc" : "使用可能資金（$）", //
        "withdraw" : "引出", //
        "withdraw_history" : "引出記録", // //
        "withdraw_show" : "資金明細確認", //
        "history_title" : "資金明細", //
        "history_empty" : "明細なし", //
        "history_all" : "全て", //
        "history_income" : "収入", //
        "history_expend" : "支出", //
    },
    withdraw:{
        "history_title" : "引出記録", //
        "history_empty" : "記録なし", //
        "history_confirm" : "当該引出をキャンセルしますか", //
        "history_confirm_title" : "キャンセル確認", //
        "title" : "引出", //
        "succ_title" : "引出申請提出済み", //
        "succ_desc" : "バックグラウンドスタッフの審査をお待ちください", //
        "amount" : "引出金額", //
        "remarks" : "備考", //
        "btn_finish" : "完了", //
        "subtitle" : "引出金額", //
        "tips" : "引出可能範囲を超えています", //
        "mentioning_balances" : "引出可能残高$", //
        "all" : "全て引き出す", //
        "remark_placeholder" : "銀行名と銀行口座を記入してください", //
        "btn_submit" : "提出", //
        "amount_empty" : "引出金額を記入してください", //
        "remark_empty" : "銀行名と銀行口座を記入してください", //
        "item_title" : "商家備考", //
        "item_amount" : "引出金額", //
        "item_time" : "申請時間", //
        "item_remark" : "会員備考", //
        "item_cancel" : "引出キャンセル", //
        "wait" : "処理待ち", //
        "finish" : "引出完了", //
        "cancel" : "キャンセル済み", //
        "failed" : "引出失敗", //
    },
    bonus:{
       "list_title" : "私の推奨", //
       "recommended" : "推奨済み", //
       "amount" : "歩合分配済み", //
       "rule" : "歩合ルール", //
       "balance" : "使用可能資金", //
       "recommend" : "私が推奨した会員", //
       "order_empty" : "推奨注文なし", //
       "recommend_rank" : "ランク", //
       "recommend_amount" : "人数", //
       "recommend_score" : "ポイント歩合", //
       "recommend_price" : "現金歩合", //
       "recommend_empty" : "推奨なし", //
       "order_sn" : "注文番号", //
       "cash" : "現金", //
       "wait" : "審査中", //
       "finish" : "歩合分配済み", //
       "cancel" : "キャンセル済み", //
       "revoke" : "キャンセル済み", //
       "type_signup" : "推奨登録歩合", //
       "type_order" : "推奨注文歩合", //
       "score_signup" : "ランクポイント", //
       "score_order" : "消費ポイント", //
       "my_qrcode" : "私のプロモーションQRコード", //
       "qr_desc" : "QRコードスキャン、私の店をフォロー", //
       "qr_share" : "店シェア", //
       "qr_copy" : "リンクコピー", //
       "qr_share_title" : "推奨歩合", //
       "qr_share_desc" : "リンクをクリックして店のプロモーション担当になって、更に多くの歩合をゲットしましょう", //
       "qr_link" : "プロモーションリンク生成完了", //
       "btn_confirm" : "確認", //
    },
    cart:{
        "title" : "カート", //购物车
        "edit" : "編集", //编辑
        "finish" : "完了", //完成
        "select_all" : "全て選択", //全选
        "total" : "合計:", //合计
        "delete" : "削除", //删除
        "checkout" : "精算", //结算
        "empty" : "あなたのショッピングカーは空です", //您的购物车还是空的
        "no_signup" : "ログイン後ショッピングカー内の商品確認が出来ます", //登录后即可查看购物车中的商品
        "gohome" : "商品を見る", //随便逛逛
        "gosignin" : "ログインする", //去登录
        "sold_out" : "完売", //已售罄
        "only_left" : "残りわずか", //仅剩
        "piece" : "件", //件
        "promos_tag" : "促進販売", //促销
        "delete_empty" : "現在削除できる商品はありません", //当前没有可删除的商品
        "no_reduce" : "もうダメ、それ以上商品の削除はできません", //
        "out_of_stock" : "当該商品在庫不足", //
        "promos" : "満足", //
        "un_promos" : "不満足のクーポン", //
        "order_promos" : "注文促進販売", //
    },
    cashgift:{
        "list_title" : "私のラッキーマネー", //
        "list_empty" : "ラッキーマネーなし", //
        "unuse" : "未使用", //
        "used" : "使用済み", //
        "expired" : "有効期限切れ", //
        "bonus_sn_placeholder" : "ラッキーマネーのシリアルナンバーを入力してください", //
        "bonus_add" : "ラッキーマネー追加", //
        "bonus_sn_empty" : "10桁のシリアルナンバーを入力してください", //
        "bonus_add_succ" : "ラッキーマネー追加完了", //
        "no_use_bonus" : "ラッキーマネー使用しない", //
        "full" : "満", //
        "can_use" : "で使用できます", //
    },
    coupon: {
		"list_title" : "我的优惠券",
		"list_empty" : "暂无优惠券",
		"full" : "满",
		"can_use" : "元可使用",
		"unuse" : "未使用",
		"used" : "已使用",
		"expired" : "已过期",
		"redbag_title" : "我的红包",
		"can_use_coupon" : "可使用优惠券",
		"no_use_coupon" : "不使用优惠券",
		"redbag_empty" : "暂无红包",
		"piece" : "张",
	},
    category:{
        "title" : "分類", //分类
        "all" : "全て", //全部
		"enter": '入ります',
		"column": 'コラム'
    },
    checkout:{
        "title" : "注文確認", //
        "title_shipping" : "配送方法", //
        "title_invoice" : "領収書種類", //
        "title_cashgif" : "ラッキーマネー使用", //
        "title_product_price" : "商品金額", //
        "title_tax_price" : "領収書税額", //
        "title_shipping_price" : "送料", //
        "total_price" : "実質支払い", //
        // "total_price_tips" : "( 価格は税別です )", //
        "btn_checkout" : "注文提出", //
        "shipping_empty" : "配送方法を選択してください", //
        "consignee_empty" : "お届け住所を記入してください", //
        "cashgift_unuse" : "未使用", //
        "cashgift_nouse" : "全て使用不可", //
        "cashgift_tips" : "1枚選択済み", //
        "cashgift_canuse" : "枚使用可能", //
        "no_invoice" : "領収書不要", //
        "invoice_type_empty" : "領収書種類を選択してください", //
        "no_shipping_price" : "送料無料", //
        "goback_mess" : "良い品物は人を待たない</br>じっくり考えてください", //
        "goback_cancel_text" : "を離れて", //
        "goback_confirm_text" : "もう少し考えてみる", //
        "invoice_header" : "領収書情報設定", //
        "invoice_type_title" : "領収書種類", //
        "invoice_tips" : "ペーパー領収書は無くしてしまう？電子式領収書を試してみよう！", //
        "invoice_title" : "領収書宛名", //
        "invoice_personal" : "個人", //
        "invoice_content" : "領収書明細", //
        "invoice_btn_submit" : "確認", //
        "invoice_empty" : "完全な領収書情報を記入してください", //
        "shipping_price" : "送料", //
        "goods_list_header" : "商品リスト", //
        "total" : "合計:", //
        "piece" : "件", //
        "score_header" : "ポイント相殺", //
        "score_most" : "最大使用可能", //
        "score" : "ポイント", //
        "deduct_from" : "一ポイントは と相殺する$", //
        "rmb" : "ドルです", //
        "no_score" : "使用可能ポイントなし", //
        "score_placeholder" : "ここにポイントを入力する", //
        "delivery_time" : "配送時間", //
        "comment_title" : "買い手メッセージ", //
        "comment_placeholder" : "オプション：今回の取引の説明（売り手と相談して合意した内容を記入する），オーダーメイド製品の需要はここにコメントしてください。", //
        "address_empty" : "お届け住所が追加されていません、ここをクリックして追加しましょう。", //
        "promos_preferential" : "値引き金額", //
        "promos_cashgift" : "ラッキーマネー", //
        "promos_score" : "ポイント", //
        "promos_order_reduction" : "注文促進販売", //
        "promos_goods_reduction" : "商品促進販売", //
        "promos_coupon_reduction" : "クーポン", //
        "promos_combined_promos" : "団体購入", //
        "promos_transport_title" : "送料", //
        'tax_header': '税金番号', // 税号
        'tax_tips': '通関に便利です', // 税号为什么要填写
        'import_duty': '関税を輸入する', // 进口关税
        'price_tips': '「 税抜き価格 」', //不含税价格!

        "coo": '原産地証明書が必要です(COO)', //需要原产地证书
        "coo_fee": 'COO 費用', //产地证书费用
        "yes": 'はい', //是
        "no": 'いいえ' //否
    },
    payment:{
        "header" : "レジ", //
        "order_succ" : "注文提出完了、支払い方法を選択してください", //
        "total_price" : "合計", //
        "teegon_wechat" : "Ping++ ウィーチャット支払い", //
        "btn_pay" : "今すぐ支払う", //
        "goback_mess" : "商品はすぐに無くなる</br>本当に支払いを放棄しますか？", //
        "goback_cancel_text" : "を離れて", //离开
        "goback_confirm_text" : "もう少し考えてみる", //
        "code_empty" : "支払い方法を選択してください", //
        "succed_header" : "購入完了", //
        "order_succed" : "注文提出完了", //
        "exchange_order_succed" : "おめでとう、交換完了", //
        "order_detail" : "注文詳細", //
    },
    discount:{
        "header" : "値引きキャンペーン", //
        "empty" : "値引きキャンペーンなし", //
        "range_0" : "全ての商品使用可能", //
        "range_1" : "一部カテゴリ使用可能", //
        "range_2" : "一部ブランド使用可能", //
        "range_3" : "一部商品使用可能", //
        "range_canuse" : "使用可能", //
        "is_end" : "キャンペーン終了", //
        "waiting" : "お待ちください",
        "is_waiting" : "キャンペーン未開始", //
        "list_empty" : "商品なし", //
        "no_more" : "それ以上はありません",
        "review_rate" : "好評", //
        "sales_count" : "販売量", //
        "surplus" : "残り", //
        "day" : "日", //
        "hour" : "時", //
        "minute" : "分", //
        "second" : "秒", //
    },
    promotions:{
        "no_more" : "それ以上はありません",
        "endtime" : "キャンペーン終了まであと時間",
        "day" : "日",
        "hour" : "時",
        "minute" : "分",
        "second" : "秒",
    },
    home:{
        "goodproduct" : "人気推奨", //热门推荐
        "hotproduct" : "販売ランキング", //销量排行
        "recentproduct" : "新商品発売", //新品上架
		"suitproducts": "組合せ商品", //组合商品
		"header_placeholder" : "何を探していますか？", //想找什么？
        "menu_activity" : "値引きキャンペーン", //优惠活动
        "menu_integralmall" : "ポイントショップ", //积分商城
        "menu_order" : "注文", //订单
        "menu_bonus" : "ラッキーマネー", //红包
        "menu1": "マルチロータ",
		"menu2": "固定翼",
		"menu3": "FPV",
		"menu4": "ロボット動力",
		"menu5": "T-DRONES",
        "product_buy" : "人が購入済み", // 人已购买
        "share_title" : "推奨歩合", //
        "share_desc" : "リンクをクリックして店のプロモーション担当になって、更に多くの歩合をゲットしましょう", //
    },
    integralmall:{
        "header" : "ポイントショップ", //
        "hotproduct" : "人気商品", //
        "allproduct" : "全ての商品", //
        "no_more" : "それ以上商品はありません", //
        "score" : "ポイント", //
    },
    message:{
        "header" : "情報センター", //
        "order" : "注文情報", //
        "notice" : "通知情報", //
        "empty" : "情報なし", //
        "no_message" : "あなたの情報通知はまだありません", //
    },
    order:{
        "header" : "私の注文", //
        "empty" : "あなたの注文はありません", //
        "gohome" : "商品を見る", //
        "copy" : "コピー", //
        "all" : "全て", //
        "created" : "支払い待ち", //
        "paid" : "発送待ち", //
        "status_cancelled" : "キャンセル済み", //
        "back_info": "振込み情報", //转账信息
        "status_finished" : "完了済み", //
        "status_deliveried" : "レビュー待ち", //
        "status_delivering" : "配送中", //
        "nav_delivering" : "受取待ち", //
        "nav_deliveried" : "レビュー待ち", //
        "comment_3" : "好評", //
        "comment_2" : "普通", //
        "comment_1" : "悪い", //
        "sn" : "注文番号", //
        "total" : "合計", //
        "total_price" : "合計", //
        "product" : "件商品", //
        "shipping_price" : "送料込み", //
        "btn_cancel" : "注文キャンセル", //
        "cancels" : "キャンセル", //
        "cancels_finish" : "完了", //
        "go_payment" : "支払いに行く", //
        "btn_track" : "物流確認", //
        "btn_confirm" : "受取確認", //
        "btn_comment" : "レビュー投稿", //
        "no_want" : "いらない", //
        "no_payment" : "支払い失敗", //
        "no_price" : "値段がやや高い", //
        "no_store" : "欠品", //
        "long_wait" : "待ち時間が長過ぎる", //
        "confirm_title" : "受取確認", //
        "confirm_content" : "受取確認しますか？", //
        "cancel_reason_empty" : "キャンセル原因を選択してください", //
        "detail_header" : "注文詳細", //
        "detail_status_0" : "支払い待ち", //
        "detail_status_1" : "発送待ち", //
        "detail_status_2" : "配送中", //
        "detail_status_3" : "レビュー待ち", //
        "detail_status_4" : "完了済み", //
        "detail_status_5" : "キャンセル済み", //
        "detail_status_6" : "配送中", //
        "detail_score" : "ポイント", //
        "detail_more" : "まだ", //
        "piece" : "件", //
        "add_time" : "発注時間", //
        "is_exchange_good_pay" : "支払い方法：ポイント交換", //
        "payment" : "支払い方法", //
        "shipping" : "配送方法", //
        "product_price" : "商品総額", //
        "tax_price" : "領収書税額", //
        "detail_shipping_price" : "送料", //
        "detail_total_price" : "実質支払い", //
        "copy_succed" : "コピー完了", //
        "no_shipping_price" : "送料無料", //
        "track_header" : "注文追跡", //
        "track_vendor_name" : "出荷出所", //
        "trade_header" : "取引完了", //
        "trade_succed" : "取引完了、売り手はあなたの支払いを受取ります！", //
        "go_comment" : "すぐにレビューする", //
        "go_detail" : "注文詳細", //
        "check_detail" : "注文確認", //
        "comment_header" : "商品レビュー", //
        "comment_submit" : "提出", //
        "comment_content" : "ここにレビューを入力してください", //
        "comment_content_empty" : "商品をレビューしてください", //
        "comment_succed" : "レビュー完了", //
        "comment_succed_tips" : "商品レビュー完了、レビューありがとうございます。", //
        "comment_gohome" : "ショッピング続ける", //
    },
    product:{
        "sort_default" : "総合ランキング", //
        "sort_price_asc" : "値段が安い順", //
        "sort_price_desc" : "値段が高い順", //
        "sort_credit_desc" : "好評率", //
        "sort_sale_desc" : "販売量順", //
        "sort_date_desc" : "新商品発売", //
        "product_tab" : "商品", //商品
        "detail_tab" : "詳細", //详情
        "evaluate_tab" : "Comments", //
		"parameter_tab": '規格', //规格参数
        "recom_tab" : "推奨設定",
        "packing_tab" : "包装リスト",
        "keyword_placeholder" : "検索したい商品を入力してください", //
        "keyword_empty" : "検索したいキーワードを入力してください", //
        "sold_out" : "完売", //
        "only_left" : "残りわずか", //
        "piece" : "件", //件
        "self_support" : "個人経営", //
        "review_rate" : "好評", //
        "sales_count" : "販売量", //
        "add_cart_succ" : "追加完了", //
        "empty" : "商品なし", //
        "no_more" : "それ以上はありません",
    },
    product_detail:{
        "total" : "全て", //
        "good" : "好評", //
        "medium" : "普通", //
        "bad" : "悪い", //
        "review" : "レビュー", //评价
        "add_cart" : "ショッピングカー追加", //加入购物车
        "fastbuy" : "今すぐ購入", //立即购买
        "exchange" : "今すぐ交換", //立即兑换
        "not_stock" : "選択した商品は欠品中、申し訳ございません！", //所选产品暂时无货，非常抱歉！
        "not_enough_score" : "ポイント不足", //积分不足
        "sure" : "確定", //确定
        "properties_empty" : "商品カテゴリを選択してください", //
        "not_enough_stock" : "商品在庫不足", //
        "exchange_title" : "交換確認", //
        "exchange_message_1" : "使用しますか", //
        "exchange_message_2" : "ポイント交換", //
        "cancel_btn" : "キャンセル", //取消
        "confirm_btn" : "確認", //确认
        "wechat_config_title" : "商品詳細", //商品详情
        "score" : "ポイント", //积分
        "在庫" : "在庫", //库存
        "数量" : "数量", //数量
        "max_number" : "商品は購入上限数量に達しました", //
        "no_reduce" : "もうダメ、それ以上商品の削除はできません", //
        "no_desc" : "本商品詳細情報なし", //本商品暂无详情
        "infobuy_number_select" : "購入を選択", //请选择购买
        "infobuy_number" : "数量分類", //数量分类
        "infobuy_selectd" : "選択済み", //已选
        "infobuy_number_selectd" : "選択済み数量", //已选数量
        "concat" : "客様サービスと連絡します", //联系客服
        "current_day" : "当日", //当天
        "next_day" : "翌日", //次日
        "month" : "月", //月
        "day" : "日", //日
        "like" : "いいね", //点赞
        "promos_time_title" : "キャンペーン終了まであと時間", //距离活动结束时间
        "day_1" : "日", //天
        "hour" : "時", //时
        "minute" : "分", //分
        "second" : "秒", //秒
        "promos_info_title" : "促進販売情報", //促销信息
        "info_header" : "商品詳細", //商品详情
        "review_content_empty" : "レビューなし", //无评价信息
        "review_empty" : "本商品レビューなし", //本商品暂无评价
        "recommend_show_all" : "全て確認", //查看全部
        "suit_goods_selected_empty" : "選択済み商品の全てのジャンルを選択してください!",
        "parameter" : "スペック",
    },
    profile:{
        "score" : "ポイント", //积分
        "record_list" : "ポイント記録", //积分记录
        "order_header" : "私の注文", //我的订单
        "order_all" : "全ての注文確認", //查看全部订单
        "order_status_0" : "支払い待ち", //待付款
        "order_status_1" : "発送待ち", //待发货
        "order_status_2" : "受取待ち", //待收货
        "order_status_3" : "完了", //完成
        "favourite_header" : "私のお気に入り", //我的收藏
        "address_header" : "お届け住所管理", //管理收货地址
        "cashgift_header" : "私のラッキーマネー", //我的红包
        "addcashgift_header" : "ラッキーマネー追加", //添加红包
        "bonus_header" : "私の推奨", //我的推荐
        "balance_header" : "私の資金", //我的资金
        "help_header" : "使用ヘルプ", //使用帮助
        "bonus_qr_header" : "私のプロモーションQRコード", //我的推广二维码
        "nickname_title" : "ログイン/登録", //登录/注册
        "setting_header" : "ヘルプガイド", //设置
        "about" : "私たちについて", //关于我们
        "contact" : "お問い合わせ",
        "Payment" : "支払いナビ",
        "help" : "注文ヘルプ",
        "Postsale" : "アフターサービスの説明",
        "warranty" : "品質保証政策",
        "signout" : "ログアウト", //退出登录
        "signout_confirm" : "ログアウト確認", //确认退出
        "info_header" : "個人情報", //个人资料
        "edit_nickname" : "ニックネーム変更", //修改昵称
        "gender" : "性別", //性别
        "edit_pwd" : "パスワード変更", //修改密码
        "male" : "男", //男
        "female" : "女", //女
        "secret" : "秘密", //保密
        "nickname_placeholder" : "ニックネームを入力", //请输入昵称
        "nickname_empty" : "请输入1-25个文字作为昵称", //
        "nickname_succ" : "ニックネーム変更完了", //修改昵称成功
        "oldpass_empty" : "パスーワードが入力されていません", //
        "pass_less" : "6-20桁文字及び符号のパスワードを入力してください", //
        "newpass_empty" : "新パスワードが入力されていません", //
        "confirpass_empty" : "確認パスワードを入力してください", //
        "confirpass_false" : "確認パスワードと入力パスワードが一致していません", //
        "btn_save" : "保存", //保存
        "add_header" : "資料補充", //
        "skip" : "スキップ", //跳过
        "add_tips" : "「*」のある項目は必ず入力してください", //
        "add_submit" : "完了", //
        "placeholder" : "入力してく", //
        "add_succ" : "資料補充完了", //
        "product_empty" : "商品なし", //
        "gohome" : "商品を見る", //
        "not_stock" : "欠品", //
        "only_left" : "残りわずか", //
        "piece" : "件", //
        "delete" : "削除", //
        "confirm_del_title" : "削除確認", //
        "confirm_del_mess" : "当該商品を削除しますか？", //
        "share" : "シェア", //
        "share_refresh" : "更新", //
        "share_to" : "にシェアする", //
        "share_wechat" : "微信", //
        "share_blog" : "微博", //
        "share_qq" : "QQ", //
        "share_cancel" : "キャンセル", //
        "change_avatar" : "アイコン変更", //
        "change_avatar_placeholder" : "アイコンを選択してください", //
        "upload" : "アップロード中...", //
        "image_type" : "必ずgif,jpeg,jpg,png,bmpの画像形式を使用してください", //
    },
    recommend:{
        "product" : "関連商品",
        "accessory" : "関係組合せ",
        "no_more" : "それ以上はありません", //没有更多了
    },
    score:{
        "header" : "私のポイント",
        "can_use" : "現在使用可能ポイント",
        "all" : "全て",
        "income" : "収入",
        "expend" : "支出",
        "empty" : "ポイント記録なし",
        "exchange_succ" : "ポイント交換完了",
        "rule_header" : "ポイントルール",
        "have_score" : "ポイントゲット",
        "expend_score" : "ポイント支払い",
        "item_score" : "ポイント",
        "platform" : "適用プラットフォーム",
        "to_exchange" : "今すぐ交換",
        "confirm_use" : "使用確認",
        "exchange_score" : "ポイント、交換",
        "coupon" : "クーポンですか？",
        "confirm_btn" : "確認",
		"tip_message" : 'まもなくゲットするポイントは支払い完了後、自動的に合計ポイントの中にチャージされます！',
		"tip_btn_text" : "わかりました",
    },
    search:{
        "header" : "最近検索",
        "hot_header" : "人気検索",
        "placeholder" : "検索したい商品を入力してください",
        "cancel" : "キャンセル",
        "keyword_empty" : "検索したいキーワードを入力してください",
    },
}



// WEBPACK FOOTER //
// ./src/assets/i18n/ja_jp.js